// SectionThree.jsx
import React, { useCallback } from "react";

/**
 * Larger/pixel-closer Section 3 component.
 * Use prop targetId to change scroll target.
 */
const ACCENT = "#b7221e"; // red used in screenshot
const BG = "#fbf7f5";

export default function SectionThree({ targetId = "contact-form" }) {
  

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Do I have to pay anything upfront?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "No. You pay nothing unless your case wins.",
        },
      },
      {
        "@type": "Question",
        name: "Are there filing fees?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "No, there are no filing fees. The independent attorneys we connect you with work on a contingency basis — they don't get paid unless your car accident case is won.",
        },
      },
    ],
  };

  return (
    <section
      id="faq-upfront"
      aria-labelledby="faq-upfront-title"
      className="w-full"
      style={{ backgroundColor: BG, fontFamily: "Poppins, ui-sans-serif, system-ui" }}
    >
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />

      <div className="max-w-6xl mx-auto px-6 md:px-8 py-16 md:py-20 lg:py-28">
        <header className="text-center">
          <h2
            id="faq-upfront-title"
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight"
            style={{ color: ACCENT, lineHeight: 1.02 }}
          >
            Do I Have to Pay Anything Upfront?
          </h2>

          <p className="mt-4 text-lg md:text-xl font-semibold text-gray-900">
            No. <span className="font-semibold">You pay nothing unless your case wins.</span>
          </p>

          <p className="mt-6 mx-auto text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl" style={{lineHeight:1.7}}>
            No, there are no filing fees. The independent attorneys we connect you with work on a
            contingency basis, which means they don't get paid unless your car accident case is won.
          </p>
        </header>

        <div className="mt-10 md:mt-12 flex justify-center">
          <button
            onClick={() => {
              const el = document.getElementById('injury-compensation-form');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            aria-label="Claim Your Free Case Review"
            className="inline-flex items-center justify-center rounded-md px-8 py-4 text-white font-semibold text-base md:text-lg
              transition transform focus:outline-none focus:ring-4 focus:ring-opacity-30"
            style={{
              background: ACCENT,
              boxShadow: "0 12px 28px rgba(183,34,30,0.18)",
            }}
          >
            <span className="block">Claim Your Free Case Review</span>
          </button>
        </div>
      </div>

      {/* Scoped hover animation for larger 'pop' effect */}
      <style>{`
        #faq-upfront button {
          transition: transform 180ms cubic-bezier(.2,.9,.2,1), box-shadow 180ms;
        }
        @media (hover: hover) and (pointer: fine) {
          #faq-upfront button:hover {
            transform: translateY(-12px);
            box-shadow: 0 22px 36px rgba(183,34,30,0.26);
          }
          #faq-upfront button:active {
            transform: translateY(-6px);
            box-shadow: 0 12px 22px rgba(183,34,30,0.18);
          }
        }
        #faq-upfront button:focus {
          box-shadow: 0 14px 30px rgba(183,34,30,0.18);
        }
      `}</style>
    </section>
  );
}
